var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var _popoverTrigger, _onTriggerEnter, _onTriggerLeave, _onPopoverEnter, _onPopoverLeave, _updatePosition, _resizeListener;
import { Component } from "@theme/component";
import { debounce, requestIdleCallback } from "@theme/utilities";
class AnchoredPopoverComponent extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "requiredRefs", ["popover", "trigger"]);
    __publicField(this, "interaction_delay", 200);
    __privateAdd(
      this,
      _popoverTrigger,
      /** @type {number | null} */
      null
    );
    __privateAdd(this, _onTriggerEnter, () => {
      const { trigger, popover } = this.refs;
      trigger.dataset.hoverActive = "true";
      if (!popover.matches(":popover-open")) {
        __privateSet(this, _popoverTrigger, setTimeout(() => {
          if (trigger.matches("[data-hover-active]")) popover.showPopover();
        }, this.interaction_delay));
      }
    });
    __privateAdd(this, _onTriggerLeave, () => {
      const { trigger, popover } = this.refs;
      delete trigger.dataset.hoverActive;
      if (__privateGet(this, _popoverTrigger)) clearTimeout(__privateGet(this, _popoverTrigger));
      if (popover.matches(":popover-open")) {
        __privateSet(this, _popoverTrigger, setTimeout(() => {
          popover.hidePopover();
        }, this.interaction_delay));
      }
    });
    __privateAdd(this, _onPopoverEnter, () => {
      if (__privateGet(this, _popoverTrigger)) clearTimeout(__privateGet(this, _popoverTrigger));
    });
    __privateAdd(this, _onPopoverLeave, () => {
      const { popover } = this.refs;
      __privateSet(this, _popoverTrigger, setTimeout(() => {
        popover.hidePopover();
      }, this.interaction_delay));
    });
    /**
     * Updates the popover position by calculating trigger element bounds
     * and setting CSS custom properties on the popover element.
     */
    __privateAdd(this, _updatePosition, async () => {
      const { popover, trigger } = this.refs;
      if (!popover || !trigger) return;
      const positions = trigger.getBoundingClientRect();
      popover.style.setProperty("--anchor-top", `${positions.top}`);
      popover.style.setProperty("--anchor-right", `${window.innerWidth - positions.right}`);
      popover.style.setProperty("--anchor-bottom", `${window.innerHeight - positions.bottom}`);
      popover.style.setProperty("--anchor-left", `${positions.left}`);
      popover.style.setProperty("--anchor-height", `${positions.height}`);
      popover.style.setProperty("--anchor-width", `${positions.width}`);
    });
    /**
     * Debounced resize handler that optionally closes the popover
     * when the window is resized, based on the data-close-on-resize attribute.
     */
    __privateAdd(this, _resizeListener, debounce(() => {
      const popover = (
        /** @type {HTMLElement} */
        this.refs.popover
      );
      if (popover && popover.matches(":popover-open")) {
        popover.hidePopover();
      }
    }, 100));
  }
  /**
   * Component initialization - sets up event listeners for resize and popover toggle events.
   */
  connectedCallback() {
    super.connectedCallback();
    const { popover, trigger } = this.refs;
    if (this.dataset.closeOnResize) {
      popover.addEventListener("beforetoggle", (event) => {
        const evt = (
          /** @type {ToggleEvent} */
          event
        );
        window[evt.newState === "open" ? "addEventListener" : "removeEventListener"]("resize", __privateGet(this, _resizeListener));
      });
    }
    if (this.dataset.hoverTriggered) {
      trigger.addEventListener("pointerenter", __privateGet(this, _onTriggerEnter));
      trigger.addEventListener("pointerleave", __privateGet(this, _onTriggerLeave));
      popover.addEventListener("pointerenter", __privateGet(this, _onPopoverEnter));
      popover.addEventListener("pointerleave", __privateGet(this, _onPopoverLeave));
    }
    if (!CSS.supports("position-anchor: --trigger")) {
      popover.addEventListener("beforetoggle", () => {
        __privateGet(this, _updatePosition).call(this);
      });
      requestIdleCallback(() => {
        __privateGet(this, _updatePosition).call(this);
      });
    }
  }
  /**
   * Component cleanup - removes resize event listener.
   */
  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener("resize", __privateGet(this, _resizeListener));
  }
}
_popoverTrigger = new WeakMap();
_onTriggerEnter = new WeakMap();
_onTriggerLeave = new WeakMap();
_onPopoverEnter = new WeakMap();
_onPopoverLeave = new WeakMap();
_updatePosition = new WeakMap();
_resizeListener = new WeakMap();
if (!customElements.get("anchored-popover-component")) {
  customElements.define("anchored-popover-component", AnchoredPopoverComponent);
}
export {
  AnchoredPopoverComponent
};
